export default __webpack_public_path__ + "static/media/human_limb.25705c2b.png";